import React, { Component } from "react";
import Countdown from "react-countdown";

const $ = window.$;

function CountdownWrapper(props) {
  const { msg, expire, submsg, promo } = props;

  const timerRender = ({ total, days, hours, minutes, seconds, completed }) => {
    let expires =
      days > 0
        ? `${days} days`
        : `${days * 24 + hours}:${String(minutes).padStart(2, "0")}:${String(
            seconds
          ).padStart(2, "0")}`;
    if (completed) {
      return (
        <div
          className="handl-countdown alert alert-danger text-center"
          role="alert"
        >
          <a
            href="#prices"
            className="scrollable"
            // onClick={(e) => {this.onPaidClick(e, 'premium')}}
          >
            Offer
          </a>{" "}
          expired :(.
        </div>
      );
    } else {
      // Render a countdown
      return (
        <div
          className={`handl-countdown alert alert-danger text-center ${promo}`}
          role="alert"
        >
          {msg}
          <p>
            {submsg}
            {days <= 5 && (
              // !this.props.promo &&
              <span>
                &nbsp;
                <a
                  href="#prices"
                  className="scrollable"
                  //onClick={(e) => {this.onPaidClick(e, 'premium')}}
                >
                  {" "}
                  offer
                </a>{" "}
                expires in{" "}
                <span className="text-success fw-500">{expires}</span>.
              </span>
            )}
          </p>
        </div>
      );
    }
  };

  return (
    <Countdown
      date={new Date(expire)}
      daysInHours={true}
      renderer={timerRender}
      onMount={() => {
        //we need to repeat this part because timer has scrollable elements
        $(
          'nav a[href^="#"]:not([href="#"]), .back_to_top, .explore, .scrollable'
        ).on("click", function (event) {
          var $anchor = $(this);
          $("html, body")
            .stop()
            .animate(
              {
                scrollTop: $($anchor.attr("href")).offset().top - 100,
              },
              1500
            );
          event.preventDefault();
        });
      }}
    />
  );

  // onPaidClick(event, plan){
  //     event.preventDefault()
  //     this.props.auth.setMainStates('flowSelected', "paid")
  //     this.props.auth.setMainStates('showPayment', true)
  //     this.props.auth.setMainStates('selected_plan', plan, () => this.props.auth.getProductPrice(''))
  // }
}

export default CountdownWrapper;
